<template>
  <v-dialog v-model="dialog.show" persistent max-width="700">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12" md="4" lg="4">
              <v-autocomplete
                v-model="form.tipo"
                :items="itemsTipo"
                label="Tipo"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field v-model="form.modelo" label="Modelo"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                v-model="form.potencia"
                label="Potência"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" lg="12">
              <v-textarea
                height="80"
                v-model="form.especificacao"
                placeholder="Especificações"
                filled
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                v-model="form.precoRegioes['Norte']"
                :rules="[rules.required, rules.isNumber]"
                label="Preço Região Norte"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                v-model="form.precoRegioes['Centro-Oeste']"
                :rules="[rules.required, rules.isNumber]"
                label="Preço Região Centro-Oeste"
                prefix="$"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                v-model="form.fabricante"
                label="Fabricante"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <UploadFileImg
                @uploadedFile="form.foto = $event"
                :foto="form.foto"
                ref="uploadFileImg"
              />
            </v-col>
            <v-col v-if="!dialog.edit" cols="12">
              <SelectEmpresa
                :multiple="true"
                @onChanged="form.empresas = $event"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="dialog.edit != true ? save() : edit()"
          >Salvar</v-btn
        >

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProdutoForca from "@/services/produtoForca";
import rules from "@/utils/rules";

export default {
  name: "DialogFormProdutoForca",

  components: {
    UploadFileImg: () => import("./UploadFileImg"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
  },

  data() {
    return {
      dialog: {
        title: "",
        show: false,
        edit: true,
      },
      produtoForca: new ProdutoForca(),
      rules,
      form: {
        ativo: true,
        dataCriacao: null,
        especificacao: "",
        potencia: "",
        empresas: [],
        fabricante: "Honda",
        foto: "",
        modelo: "",
        tipo: "",
        precoRegioes: {
          "Centro-Oeste": 0,
          Norte: 0
        }
      },
      produtoForcaId: "",
      itemsTipo: [
        "CORTADORES DE GRAMA",
        "GERADORES",
        "MOTOBOMBAS",
        "MOTORES ESTACIONARIOS",
        "MOTORES ESTACIONARIOS CYCLONE",
        "MOTORES ESTACIONARIOS MEGA",
        "MOTORES ESTACIONARIOS SUPER",
        "ROÇADEIRAS"
      ]
    };
  },

  methods: {

    show(edit, veiculo) {
      if (edit) {
        this.editItem(veiculo);
      } else {
        this.form.dataCriacao = new Date();
        this.dialog.title = "Criar Novo Protudo";
      }
      this.dialog.edit = edit;
      this.dialog.show = true;
    },

     editItem(veiculo) {
      this.dialog.title = "Editar Protudo";
      this.produtoForcaId = veiculo.id;
      this.form.tipo = veiculo.tipo;
      this.form.potencia = veiculo.potencia;
      this.form.especificacao = veiculo.especificacao;
      this.form.dataCriacao = veiculo.dataCriacao;
      this.form.empresas = veiculo.empresas;
      this.form.fabricante = veiculo.fabricante;
      this.form.foto = veiculo.foto;
      this.form.modelo = veiculo.modelo;
      this.form.precoRegioes["Centro-Oeste"] =
        veiculo.precoRegioes["Centro-Oeste"];
      this.form.precoRegioes["Norte"] = veiculo.precoRegioes["Norte"];
    },

    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.convertValuesTofloat();
            let newProduto = await this.produtoForca.create(this.form);
            this.$emit("created", newProduto);
          
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async edit() {
      try {
        if (this.$refs.form.validate()) {
            await this.produtoForca.update(this.produtoForcaId, this.form);
           this.$emit("updated", [this.form, this.produtoForcaId]);
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    close() {
      this.dialog.show = false;
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.$refs.uploadFileImg.reset();
    },

    convertValuesTofloat() {
      this.form.precoRegioes["Centro-Oeste"] = parseFloat(
        this.form.precoRegioes["Centro-Oeste"]
      );
      this.form.precoRegioes["Norte"] = parseFloat(
        this.form.precoRegioes["Norte"]
      );
    }
  }
};
</script>
